import {TextItem} from "./text-item/text-item";
import {PlayerPoint} from "./player/point";
import {ImageItem} from "./image-item";
import {User} from "../core/user";

export class PodcastItem {
    id: number;
    name: string;
    description: string;
    tags: string;
    parsedTags: string[]
    textBody: string;
    textItems: TextItem[] = [];
    stopPoints: PlayerPoint[] = [];
    podcastImages: ImageItem[] = [];
    podcastAudio: string;
    podcastAudioData: string;
    is_public: boolean;
    is_my: boolean;
    secret: string;
    currentPodcastImage: ImageItem;
    createDate: string;
    user: User;

    truncatedText(maxlength:number = 26) {
        let str = this.name;
        if (str.length > maxlength) {
            return str.slice(0, maxlength - 3) + '...';
        }

        return str;
    }
}
